<template>
  <div>
    <v-row dense :key="order.id" class="mb-15">
      <template v-if="step == 1">
        <v-col cols="12" md="6">
          <CustomerInfo
            :info="order"
            :channels="channels"
            :countries="countries"
            :summary="summary"
            :is-show-all="false"
            ref="customerInfoRef"
            @onUpdate="onUpdate"
            @onDocumentRead="onDocumentRead"
          />
        </v-col>
        <v-col cols="12" md="6">
          <PartnerItems
            :key="`partner_items_${order.id}_${services.length}_${assets.length}`"
            :info="order"
            :services="services"
            :assets="assets"
            :summary="summary"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
        <v-col cols="12" md="6">
          <CollaboratorDelivery
            :key="`collaborator_delivery_${order.id}_${branches.length}`"
            :info="order"
            :services="services"
            :branches="branches"
            :summary="summary"
            ref="itemRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
      <template v-else-if="step == 2">
        <v-col cols="12" md="12">
          <Payment
            :info="order"
            :summary="summary"
            :is-show-card-payment="false"
            ref="paymentRef"
            @onUpdate="onUpdate"
            @goBack="goBack"
          />
        </v-col>
      </template>
      <template v-else-if="step == 3">
        <v-col cols="12" md="12">
          <Success
            :info="order"
            :summary="summary"
            type="partner"
            ref="successRef"
            @onUpdate="onUpdate"
          />
        </v-col>
      </template>
    </v-row>
    <div class="fixed-bottom-block">
      <v-row dense>
        <template v-if="step == 1">
          <v-col cols="6">
            <v-btn color="error" small block @click="resetAll">
              {{ order.id ? $t("Hủy đơn") : $t("Làm lại") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="success"
              small
              block
              :disabled="!documentRead"
              @click="saveProcessing"
            >
              {{ $t("Tiếp") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 2">
          <v-col cols="12">
            <v-btn color="warning" small block @click="goBack">
              {{ $t("Quay lại") }}
            </v-btn>
          </v-col>
        </template>
        <template v-else-if="step == 3">
          <v-col cols="12">
            <v-btn
              color="purple"
              class="white--text"
              small
              block
              @click="pageReload"
            >
              {{ $t("Thêm yêu cầu mới") }}
            </v-btn>
          </v-col>
        </template>
      </v-row>
    </div>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import { debounce } from "lodash";
import { ORDER_STATUS } from "@/libs/const";

export default {
  name: "Collaborator",
  components: {
    CustomerInfo: () => import("@/components/rent/CustomerInfo"),
    PartnerItems: () => import("@/components/rent/PartnerItems"),
    CollaboratorDelivery: () =>
      import("@/components/rent/CollaboratorDelivery"),
    Payment: () => import("@/components/rent/Payment"),
    Success: () => import("@/components/rent/Success"),
  },
  data: () => ({
    order: {
      id: "",
    },
    channels: [],
    countries: [],
    services: [],
    vouchers: [],
    assets: [],
    branches: [],
    step: 1,
    isLoading: false,
    documentRead: false,
  }),
  computed: {
    selectedService() {
      if (
        !this.order.rent_day ||
        !this.order.id_asset ||
        !this.order.delivery_id_city
      ) {
        return [];
      }

      return [...this.services].find(
        (s) =>
          s.id_asset == this.order.id_asset &&
          s.id_city == this.order.delivery_id_city &&
          s.from_day <= this.order.rent_day &&
          s.to_day >= this.order.rent_day
      );
    },
    summary() {
      const data = {
        total_price: 0,
        id_service: 0,
      };

      if (!this.selectedService) {
        return data;
      }

      const itemAmount = this.selectedService.price * this.order.rent_day;
      data.total_price += itemAmount;
      data.id_service = this.selectedService.id;

      return data;
    },
  },
  mounted() {
    this.getProcessing();
    this.getAssets();
    this.getCountries();
    this.getChannels();
    this.getServices();
    this.getBranch();
    this.listenSocket();
  },
  methods: {
    async getBranch() {
      const { data } = await httpClient.post("/me/v1/get-branch");
      this.branches = [...data];
    },
    onDocumentRead() {
      this.documentRead = true;
    },
    async getProcessing() {
      const res = await httpClient.post("/order/v1/get-processing-partner");
      if (res && res.data && res.data.id) {
        const { data } = await httpClient.post("/order/v1/get-detail", {
          id_order: res.data.id,
        });
        if (data.status == ORDER_STATUS.DEPOSIT) {
          this.step = 3;
        }
        this.order = { ...data };
        this.onDocumentRead();
      }
    },
    async resetAll() {
      if (this.order.id) {
        const id_order = this.order.id;
        await httpClient.post("/order/v1/cancel-processing", {
          id_order,
        });
      }
      this.step = 1;
    },

    pageReload() {
      window.location.reload();
    },

    nextStep() {
      this.step++;
    },
    goBack() {
      this.step--;
    },

    onUpdate: debounce(function (order) {
      this.order = { ...this.order, ...order };
    }, 200),

    async saveProcessing() {
      if (!this.summary.id_service) {
        this.$vToastify.error(this.$t("Không có dịch vụ khả dụng"));
        return false;
      }

      if (!this.order.start_time) {
        this.$vToastify.error(this.$t("Chưa chọn thời gian nhận xe"));
        return false;
      }

      const { data } = await httpClient.post(
        "/order/v1/save-processing-collaborator",
        {
          ...this.order,
          ...this.summary,
        }
      );
      this.order = { ...this.order, ...data };

      this.nextStep();
    },

    listenSocket() {
      window.socket.on("order_paid", (data) => {
        console.log("listenSocket->data", data);

        const { id_order } = data;

        if (id_order == this.order.id && this.step == 2) {
          this.step = 3;
        }
      });
    },

    async getCountries() {
      const { data } = await httpClient.post("/common/v1/get-country");
      this.countries = [...data];
    },

    async getChannels() {
      const { data } = await httpClient.post("/common/v1/get-channel", {
        type: 2,
      });
      this.channels = [...data];
    },

    async getAssets() {
      const { data } = await httpClient.post(
        "/asset/v1/get-by-city-for-partner"
      );
      this.assets = [...data];
    },

    async getServices() {
      const { data } = await httpClient.post("/common/v1/get-service");
      this.services = [...data];
    },
  },
};
</script>
